export default "__VITE_ASSET__B9t0OO4a__"